<template>
  <el-dialog
      title="违章设置"
      :visible="visible"
      width="60%"
      :close-on-click-modal="false"
      @open="handleOpen"
      @update:visible="$emit('update:visible', $event)"
  >
    <el-tabs v-model="activeSettingTab">
      <el-tab-pane label="违章设置" name="setting">
        <el-form :model="violationSetting" ref="violationSettingForm" label-width="180px" size="small" label-position="top">
          <el-divider content-position="left">超速设置</el-divider>
          <el-form-item label="超速判定阈值(km/h)：">
            <el-input-number
              v-model="violationSetting.overSpeedMaxSpeed"
              :min="0"
              :max="200"
              placeholder="请输入速度值"
            ></el-input-number>
          </el-form-item>
          <el-divider content-position="left">违停设置</el-divider>
          <el-form-item label="违停扣分：">
            <el-input-number
              v-model="violationSetting.illegalParkingScore"
              :min="0"
              :max="12"
              placeholder="请输入扣分值"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="违停是否发送短信通知：">
            <el-switch
              v-model="violationSetting.illegalParkingSendMessage"
              active-text="是"
              inactive-text="否"
            ></el-switch>
          </el-form-item>
          <el-divider content-position="left">拉黑设置</el-divider>
          <el-form-item label="最大违章次数（拉黑阈值）：">
            <el-input-number
              v-model="violationSetting.maxViolationCount"
              :min="0"
              :max="100"
              placeholder="请输入次数"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="违章类型管理" name="typeManage">
        <el-form :model="vtQuery" ref="vtQuery" label-position="100px" size="mini" inline="true">
          <el-form-item label="类型名称" prop="name">
            <el-input v-model="vtQuery.name" clearable></el-input>
          </el-form-item>
          <el-button type="primary" @click="vtFetchData">查询</el-button>
          <el-button @click="vtReset">重置</el-button>
          <el-button type="primary" @click="vtShowAddDialog">添加</el-button>
        </el-form>
        <el-table
            :data="vtData"
            border
            fit
            highlight-current-row
            :height="400"
            ref="vtTable"
            size="mini"
            style="margin-top: 12px;">
          <el-table-column label="id" prop="id" width="105"/>
          <el-table-column label="违章类型名称" prop="name" width=""/>
          <el-table-column label="排序号" prop="sort"/>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="vtShowUpdateDialog(scope.row)">详情</el-button>
              <el-button type="text" size="mini" @click="vtRemove(scope.row)" style="color: #f12">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            background
            @size-change="vtHandleSizeChange"
            @current-change="vtHandleCurrentChange"
            :current-page="vtPageInfo.current"
            :page-sizes="[15, 50, 100, 200]"
            :page-size="vtPageInfo.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="vtPageInfo.total"
            style="text-align: right; margin-top: 10px;"/>

        <el-dialog :visible.sync="vtAddDialogVisible" title="添加" top="20vh" width="600px" :append-to-body="true">
          <el-form ref="vtAddForm" :model="vtAddForm" label-width="200px" size="mini">
            <el-form-item label="类型名称(不能超过六个字符)" required>
              <el-input v-model="vtAddForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="排序号" required>
              <el-input-number v-model="vtAddForm.sort" :min="0" :max="30" label="描述文字"></el-input-number>
            </el-form-item>
          </el-form>
          <div style="text-align: right; margin-top: 15px;">
            <el-button type="text" @click="vtAddDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="vtAdd()">提交</el-button>
          </div>
        </el-dialog>

        <el-dialog :visible.sync="vtEditDialogVisible" title="修改" top="20vh" width="600px" :append-to-body="true">
          <el-form ref="vtEditForm" :model="vtEditForm" label-width="200px" size="mini">
            <el-form-item label="类型名称(不能超过六个字符)" required>
              <el-input v-model="vtEditForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="排序号" required>
              <el-input-number v-model="vtEditForm.sort" :min="0" :max="30" label="描述文字"></el-input-number>
            </el-form-item>
          </el-form>
          <div style="text-align: right; margin-top: 15px;">
            <el-button type="text" @click="vtEditDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="vtUpdate()">提交</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="dialog-footer" v-if="activeSettingTab === 'setting'">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="saveViolationSetting()" :loading="saving">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getViolationSetting, setViolationSetting } from "./api/index"
import request from '@/utils/apiRequest'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeSettingTab: 'setting',
      saving: false,
      violationSetting: {
        illegalParkingScore: 0,
        illegalParkingSendMessage: false,
        overSpeedMaxSpeed: 60,
        maxViolationCount: 5
      },
      // 违章类型管理
      vtQuery: {
        name: '',
      },
      vtData: [],
      vtPageInfo: {
        current: 1,
        size: 15,
        total: 0
      },
      vtAddDialogVisible: false,
      vtAddForm: {},
      vtEditDialogVisible: false,
      vtEditForm: {},
    }
  },
  methods: {
    handleOpen() {
      this.activeSettingTab = 'setting';
      this.loadViolationSetting();
      this.vtFetchData();
    },
    handleClose() {
      this.$emit('update:visible', false);
    },

    // 加载违章设置
    loadViolationSetting() {
      this.saving = true;
      getViolationSetting()
        .then((res) => {
          if (res.data && res.data.code === 20000) {
            const data = res.data.data || {};
            this.violationSetting = {
              illegalParkingScore: data.illegalParkingScore || 0,
              illegalParkingSendMessage: data.illegalParkingSendMessage !== undefined ? data.illegalParkingSendMessage : false,
              overSpeedMaxSpeed: data.overSpeedMaxSpeed || 60,
              maxViolationCount: data.maxViolationCount || 5
            };
          } else {
            this.$message.warning(res.data.message || '获取设置失败');
          }
        })
        .catch((err) => {
          console.error('获取设置出错:', err);
          this.$message.error('服务器发生错误，请联系系统管理员');
        })
        .finally(() => {
          this.saving = false;
        });
    },

    // 保存违章设置
    saveViolationSetting() {
      this.$refs.violationSettingForm.validate((valid) => {
        if (valid) {
          this.saving = true;
          setViolationSetting(this.violationSetting)
            .then((res) => {
              if (res.data && res.data.code === 20000) {
                this.$message.success('保存成功');
                this.$emit('update:visible', false);
              } else {
                this.$message.warning(res.data.message || '保存失败');
              }
            })
            .catch((err) => {
              console.error('保存设置出错:', err);
              this.$message.error('服务器发生错误，请联系系统管理员');
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },

    // ===== 违章类型管理 =====
    vtBuildQueryForm() {
      const queryForm = {...this.vtQuery, ...this.vtPageInfo}
      delete queryForm.total
      return queryForm
    },
    vtFetchData() {
      const queryForm = this.vtBuildQueryForm()
      queryForm.scope = 0
      request({
        url: '/user/violationType/listPage',
        params: queryForm,
        method: 'get'
      }).then(res => {
        this.vtData = res.data.records
        this.vtPageInfo.current = res.data.current
        this.vtPageInfo.size = res.data.size
        this.vtPageInfo.total = res.data.total
      })
    },
    vtHandleSizeChange(size) {
      this.vtPageInfo.size = size
      this.vtFetchData()
    },
    vtHandleCurrentChange(current) {
      this.vtPageInfo.current = current
      this.vtFetchData()
    },
    vtReset() {
      this.$refs.vtQuery.resetFields();
      this.vtQuery = {}
      this.vtFetchData()
    },
    vtShowAddDialog() {
      this.vtAddForm = { score: 1, scope: 0 }
      this.vtAddDialogVisible = true
    },
    vtAdd() {
      request({
        url: '/user/violationType/addOrUpdate',
        data: this.vtAddForm,
        method: 'post',
        loading: true
      }).then(res => {
        this.vtAddForm = { score: 1, scope: 0 }
        this.vtAddDialogVisible = false
        this.vtFetchData()
        this.$message.success('操作成功')
      })
    },
    vtShowUpdateDialog(editData) {
      this.vtEditForm = editData
      this.vtEditDialogVisible = true
    },
    vtUpdate() {
      request({
        url: '/user/violationType/addOrUpdate',
        data: this.vtEditForm,
        method: 'post',
        loading: true
      }).then(res => {
        this.vtEditForm = {}
        this.vtFetchData()
        this.$message.success('操作成功')
      })
    },
    vtRemove(row) {
      this.$confirm('是否删除当前记录？删除后不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/user/violationType/remove',
          params: { id: row.id },
          method: 'get',
          loading: true
        }).then(res => {
          this.$message.success('操作成功')
          this.vtFetchData()
        })
      });
    },
  },
}
</script>
